export default {"src":"/_next/static/media/starMask.05d21f06.svg","height":766,"width":766,"blurWidth":0,"blurHeight":0};